export const SESSION_STORAGE_KEY = 'web_app_session';
export const TIME_BUTTONS = [
  {
    label: '1h',
    value: { hours: 1 },
  },
  {
    label: '3h',
    value: { hours: 3 },
  },
  {
    label: '12h',
    value: { hours: 12 },
  },
  {
    label: '1d',
    value: { days: 1 },
  },
  {
    label: '3d',
    value: { days: 3 },
  },
  {
    label: '1w',
    value: { days: 7 },
  },
];
export const DASHBOARD_TIME_BUTTONS = [
  {
    label: '1h',
    value: { hours: 1 },
    tooltip: 'Last hour',
  },
  {
    label: '3h',
    value: { hours: 3 },
    tooltip: 'Last 3 hours',
  },
  {
    label: 'Day',
    value: { days: 1 },
    tooltip: 'Last day',
  },
  {
    label: 'Week',
    value: { days: 7 },
    tooltip: 'Last week',
  },
];
